import { css } from "@emotion/react";

import { colors } from "../../../../styles";

export const listingAgent = css`
  background-color: ${colors.white};
  padding: 15px;
  border-radius: 5px;
  margin-top: 20px;
  margin-right: 20px;

  @media only screen and (max-width: 40em) {
    margin-right: 0;
  }
`;

export const container = css`
  margin-bottom: 10px;
`;

export const header = css`
  margin: 0;
  font-size: 1.75rem;
`;

export const position = css`
  margin: 0;
`;

export const details = css`
  list-style-type: none;
  margin: 0;
`;

export const waveContainer = css`
  width: 100%;
  height: auto;
  margin-top: 15px;
`;
